// extracted by mini-css-extract-plugin
export var container = "_fc-0";
export var dotAnimation = "_fc-2";
export var dotsLoading = "_fc-1";